export const salesdata = [
    {
        month: "January",
        "fuel": 3000,
    },
    {
        month: "Feb",
        "fuel": 6000,
    },
    {
        month: "March",
        "fuel": 3000,
    },
    {
        month: "April",
        "fuel": 4000,
    },
    {
        month: "May",
        "fuel": 7000,
    },
    {
        month: "June",
        "fuel": 5000,
    },
    {
        month: "July",
        "fuel": 4000,
    },
    {
        month: "August",
        "fuel": 6000,
    },
    {
        month: "Sept",
        "fuel": 5000,
    },
    {
        month: "Oct",
        "fuel": 7000,
    },
    {
        month: "Nov",
        "fuel": 8000,
    },
    {
        month: "Dec",
        "fuel": 4000,
    },


];


export const clientlistrows = [
    {
        id: 1,
        clientname: "Kipruto Kiplangat",
        avatar: "https://www.capitalfm.co.ke/news/files/2020/06/PHOTO-2020-06-21-15-24-51.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "12:00 AM",
        transaction: "10,000",
    },

    {
        id: 2,
        clientname: "Vivian Ayeko",
        avatar: "https://ak.picdn.net/offset/photos/5f4923daa75ca0db3709faa6/medium/offset_995180.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "10:00 AM",
        transaction: "10,000",
    },

    {
        id: 3,
        clientname: "MMUST Transtport",
        avatar: "https://image.shutterstock.com/image-illustration/cartoon-character-little-boy-points-260nw-1550040197.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "07:00 PM",
        transaction: "10,000"
    },

    {
        id: 4,
        clientname: "Kakamega Hillschool",
        avatar: "https://www.capitalfm.co.ke/news/files/2020/06/PHOTO-2020-06-21-15-24-51.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "08:00 AM",
        transaction: "10,000"
    },

    {
        id: 5,
        clientname: "Felix Jakom",
        avatar: "https://netstorage-tuko.akamaized.net/images/534a9b245f131a57.jpg?imwidth=900",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "05:00 PM",
        transaction: "10,000"
    },

    {
        id: 6,
        clientname: "Irene Shibala",
        avatar: "https://www.capitalfm.co.ke/news/files/2020/06/PHOTO-2020-06-21-15-24-51.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "12:00 AM",
        transaction: "10,000",
    },

    {
        id: 7,
        clientname: "Felix Olela",
        avatar: "https://ichef.bbci.co.uk/news/976/cpsprodpb/C448/production/_117684205_lotus.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "12:00 AM",
        transaction: "10,000",
    },

    {
        id: 8,
        clientname: "Mark Vihiga",
        avatar: "https://live.staticflickr.com/6053/6329340636_427b318e0d_c.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "12:00 AM",
        transaction: "10,000",
    },

    {
        id: 9,
        clientname: "Vincent Laban",
        avatar: "https://www.capitalfm.co.ke/news/files/2020/06/PHOTO-2020-06-21-15-24-51.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "12:00 AM",
        transaction: "10,000",
    },

    {
        id: 10,
        clientname: "Kipruto Kiplangat",
        avatar: "https://www.capitalfm.co.ke/news/files/2020/06/PHOTO-2020-06-21-15-24-51.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "12:00 AM",
        transaction: "10,000",
    },

    {
        id: 11,
        clientname: "Kipruto Kiplangat",
        avatar: "https://www.capitalfm.co.ke/news/files/2020/06/PHOTO-2020-06-21-15-24-51.jpg",
        email: "olelafelix@gmail.com",
        phone_no: "+254710605896",
        logbook_no: "SIGY4235",
        vehicleno_plate: "KDA 8343G",
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        lastseen: "12:00 AM",
        transaction: "10,000",
    },
];


export const productlistrows = [
    {
        id: 1,
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        exactinstalationpoint: "dashboard",
        installationdate: "12:00 AM",
        last_data_bundle_purchase_date: "12,:00 AM",
        data_bundle_balance: "3000 MB",
        embededphone_no: "+254710607534",

    },
    {
        id: 2,
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        exactinstalationpoint: "driversseat",
        installationdate: "12:00 AM",
        last_data_bundle_purchase_date: "12,:00 AM",
        data_bundle_balance: "3000 MB",
        embededphone_no: "+254710607534",

    },
    {
        id: 3,
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        exactinstalationpoint: "dashboard",
        installationdate: "12:00 AM",
        last_data_bundle_purchase_date: "12,:00 AM",
        data_bundle_balance: "3000 MB",
        embededphone_no: "+254710607534",

    },
    {
        id: 4,
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        exactinstalationpoint: "ceiling",
        installationdate: "12:00 AM",
        last_data_bundle_purchase_date: "12,:00 AM",
        data_bundle_balance: "3000 MB",
        embededphone_no: "+254710607534",

    },
    {
        id: 5,
        trackig_tocken: "CSASFAGCFC",
        status: "Active",
        exactinstalationpoint: "seatno3",
        installationdate: "12:00 AM",
        last_data_bundle_purchase_date: "12,:00 AM",
        data_bundle_balance: "3000 MB",
        embededphone_no: "+254710607534",

    },

];

export const productData = [
    {
        name: "Jan",
        "Sales": 4000,
    },
    {
        name: "Feb",
        "Sales": 3000,
    },
    {
        name: "Mar",
        "Sales": 5000,
    },
];